<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm @submit.prevent="login" method="POST">
                <CAlert
                  closeButton
                  :show.sync="alertIsShown"
                  color="danger"
                  fade
                >
                  {{ message }}
                </CAlert>
                <h1>Σύνδεση</h1>
                <p class="text-muted">Συνδεθείτε στον λογαριασμό σας</p>
                <CInput
                  v-model="email"
                  prependHtml="<i class='cui-user'></i>"
                  placeholder="Email"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  placeholder="Κωδικός Πρόσβασης"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton type="submit" color="primary" class="px-4">Σύνδεση</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-md-down-none"
            body-wrapper
          >
            <CCardBody class="d-flex"> 
              <img id="mainLogo" src="/images/BQV_LOGO_red.png?95e27d6adad0e03f4ae2ee0ecb046615" alt="Responsive image" class="img-fluid">
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>

import axios from "axios";

    export default {
      name: 'Login',
      data() {
        return {
          email: '',
          password: '',
          showMessage: false,
          alertIsShown: false,
          message: '',
        }
      },
      computed: {
        alertModal: {
          get() {
            return this.dismissCountDown > 0;
          },
          set() {
            this.dismissCountDown = 0;
          }
        }
      },
      watch: {
        alertIsShown: function(newVal, oldVal) {
          if (! newVal && this.saved) {
            this.$emit('closed-alert');
          }
        }
      },
      methods: {
        showAlert () {
          this.alertIsShown = true
        },
        login() {
          let self = this;
          axios.post('/api/login', {
            email: self.email,
            password: self.password,
          }).then(function (response) {
            self.email = '';
            self.password = '';
            localStorage.setItem("api_token", response.data.access_token);
            self.$router.push({ path: 'cases' });
          })
          .catch(function (error) {
            self.message = 'Λάθος e-mail ή κωδικός πρόσβασης';
            self.showMessage = true;
            console.log(error);

            self.showAlert();
          });

        }
      }
    }

</script>
